import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Modal,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Slider from "react-slick";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import { OrbitProgress, BlinkBlur } from "react-loading-indicators";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1300,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const Fueldetailstab = ({
  selectedRow,
  setSelectedRow,
  setOpenTab,
  getFuelListApi,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const fuelTypes = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;

  function createData(TransactionId, Amount, Charges, Payment, Remarks, Image) {
    return {
      TransactionId,
      Amount,
      Charges,
      Payment,
      Remarks,
      attachments: Image,
    };
  }

  const [fuelDetails, setFuelDetails] = useState(null);
  const [attachements, setAttachments] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [extraAttachments, setExtraAttachments] = useState(null);
  const [imageSelection, setImageSelection] = useState(null);

  const handleClose = () => {
    setImageSelection(null);
    setOpen(false);
  };

  const handleOpen = (url) => {
    setImageSelection(url);
    setOpen(true);
  };

  const rows = transactionList.map((item) =>
    createData(
      item?.transactionId || "-",
      item?.transactionAmount || "-",
      item?.transactionCharges || "-",
      item?.modeOfPayment || "-",
      item?.transactionRemark || "-",
      typeof item?.attachments === "string"
        ? JSON.parse(item.attachments)
        : item.attachments || null
    )
  );

  // useEffect(() => {
  //   if (!fuelDetails) return;

  //   const safeParse = (jsonString) => {
  //     try {
  //       const parsed = JSON.parse(jsonString);
  //       return Array.isArray(parsed) ? parsed : parsed?.url;
  //     } catch {
  //       return [];
  //     }
  //   };

  //   setAttachments([
  //     {
  //       title: "Pre Fill Fuel Images",
  //       images: safeParse(fuelDetails?.preFillFuelAttachments),
  //     },
  //     {
  //       title: "Post Fill Fuel Images",
  //       images: safeParse(fuelDetails?.postFillFuelAttachments),
  //     },
  //     {
  //       title: "Bill Attachments",
  //       images: safeParse(fuelDetails?.billAttachments),
  //     },
  //     {
  //       title: "Attachments",
  //       images: safeParse(fuelDetails?.attachments),
  //     },
  //   ]);
  // }, [fuelDetails]);

  useEffect(() => {
    if (!fuelDetails) return;

    const safeParse = (input) => {
      if (!input) return [];

      // If it's already an array, return as-is
      if (Array.isArray(input)) return input;

      // If it's a stringified JSON (like from DB), try parsing it
      if (typeof input === "string") {
        try {
          const parsed = JSON.parse(input);
          if (Array.isArray(parsed)) return parsed;
          if (parsed?.url) return [parsed]; // Wrap single object into array
          return [];
        } catch {
          return [];
        }
      }

      // If it's an object with a url, wrap in array
      if (typeof input === "object" && input?.url) {
        return [input];
      }

      return [];
    };

    setAttachments([
      {
        title: "Pre Fill Fuel Images",
        images: safeParse(fuelDetails?.preFillFuelAttachments),
      },
      {
        title: "Post Fill Fuel Images",
        images: safeParse(fuelDetails?.postFillFuelAttachments),
      },
      {
        title: "Bill Attachments",
        images: safeParse(fuelDetails?.billAttachments),
      },
      // {
      //   title: "Attachments",
      //   images: safeParse(fuelDetails?.attachments),
      // },
    ]);

    setExtraAttachments(safeParse(fuelDetails?.attachments));
  }, [fuelDetails]);

  const getFuelcashDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/fuellogs/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data) {
        setLoading(false);
        setFuelDetails(data?.entityValue);
        setTransactionList(data?.entityValue?.transactionList);
        // await getUsersLimitDetails()
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching fuel cash details:", error);
    }
  };

  // const getUsersLimitDetails = async () => {
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/api/users?limit=1000&isSystemUser=1`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       setUserList(data?.entities?.rows);
  //     } else {
  //       console.error("Unexpected API response:", data);
  //     }
  //   } catch (error) {
  //     console.error(
  //       "Error fetching user limits list in the fuel details tab:",
  //       error
  //     );
  //   }
  // };
  // useEffect(() => {
  //   getUsersLimitDetails();
  // }, []);

  useEffect(() => {
    if (selectedRow?.fuellogid) {
      setLoading(true);
      getFuelcashDetails(selectedRow?.fuellogid);
    }
  }, [selectedRow]);

  return (
    <>
      {open && (
        <Modal
          keepMounted
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <div>
              <img                
                className="h-full w-full"
                src={imageSelection}
                alt="attachment"
              />
            </div>
          </Box>
        </Modal>
      )}

      <div className="md:p-6 h-screen overflow-y-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <div className="flex justify-between">
          <h2 className="text-xl md:text-2xl font-bold text-gray-700 mb-4">
            Fuel Details
          </h2>
          <Button
            onClick={() => {
              setSelectedRow(null);
              setOpenTab(false);
              getFuelListApi();
            }}
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            sx={{
              fontWeight: "bold",
              backgroundColor: "#1a53ff",
              color: "white",
            }}
            className="rounded-full"
          >
            Go Back
          </Button>
        </div>
        {loading ? (
          <>
            <div className="flex items-center justify-center h-screen w-full">
              {/* <OrbitProgress
                variant="spokes"
                color="#050dff"
                size="large"
                text="Data Loading"
                textColor="#aeb7fb"
              /> */}
              <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
            </div>
          </>
        ) : (
          <div className="p-6 bg-white shadow-md rounded-lg space-y-6 mt-6">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 mt-4 gap-6">
              {[
                { label: "ID", value: fuelDetails?.id || "-" },
                {
                  label: "Vehicle Id",
                  value: fuelDetails?.vehicleId || "-",
                },
                {
                  label: "Vehcile Name",
                  value: fuelDetails?.vehicleName
                    ? fuelDetails?.vehicleName
                    : "-",
                },
                {
                  label: "Vehicle No",
                  value: fuelDetails?.registrationNo || "-",
                },
                { label: "Amount", value: fuelDetails?.amount || "-" },
                {
                  label: "Filled By",
                  value: fuelDetails?.filledBy || "-",
                },
                {
                  label: "City",
                  value: fuelDetails?.cityText ? fuelDetails?.cityText : "-",
                },
                { label: "Hub", value: fuelDetails?.hubText || "-" },
                {
                  label: "Fuel Type",
                  value: fuelDetails?.fuelTypeDetails || "-",
                },
                {
                  label: "Liters Filled",
                  value: fuelDetails?.filledQunatity || "-",
                },
                {
                  label: "Price Per Liter",
                  value: fuelDetails?.currentFuelPrice || "-",
                },
                {
                  label: "Bill No",
                  value: fuelDetails?.billNo || "-",
                },
                {
                  label: "Pre Fuel Reading",
                  value: fuelDetails?.preFillFuelReading + "%",
                },
                {
                  label: "Post Fuel Reading",
                  value: fuelDetails?.postFillFuelReading + "%",
                },
                {
                  label: "Booking Id",
                  value: fuelDetails?.bookingId || "N/A",
                },
                {
                  label: "Created By",
                  value: fuelDetails?.fleetAgentDetails?.name || "-",
                },
              ].map(({ label, value, isStatus }, idx) => (
                <div key={idx} className="p-1">
                  <h2 className="text-sm font-medium p-1 rounded-lg bg-gray-200 text-center text-gray-600 mb-1">
                    {label}
                  </h2>
                  {isStatus ? (
                    <p
                      className={`inline-block px-3 py-1 text-center mx-auto rounded-lg text-sm font-semibold`}
                    >
                      {value}
                    </p>
                  ) : (
                    <p className="text-gray-800 mt-2 text-center font-medium">
                      {value}
                    </p>
                  )}
                </div>
              ))}
            </div>

            <hr />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 border-2 border-lg p-4 rounded-lg">
              {attachements?.map((item, index) => (
                <div className="my-6" key={index}>
                  <h1 className="text-md text-center font-semibold mb-2">
                    {item?.title}
                  </h1>

                  {item?.images?.length > 1 ? (
                    <Slider
                      dots
                      infinite
                      speed={500}
                      slidesToShow={1}
                      slidesToScroll={1}
                      arrows
                    >
                      {item.images.map((img, idx) => (
                        <div key={idx}>
                          <img
                            src={img?.url ? img?.url : img?.path}
                            alt={`Preview ${idx}`}
                            onClick={() => {
                              handleOpen(img?.url ? img?.url : img?.path);
                            }}
                            className="w-full h-64 mt-2 object-contain cursor-pointer rounded"
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : item?.images?.length === 1 ? (
                    <img
                      src={
                        item?.images[0]?.url
                          ? item?.images[0]?.url
                          : item?.images[0]?.path
                      }
                      onClick={() => {
                        handleOpen(
                          item?.images[0]?.url
                            ? item?.images[0]?.url
                            : item?.images[0]?.path
                        );
                      }}
                      alt="Preview"
                      className="w-full h-64 mt-2 object-contain cursor-pointer rounded"
                    />
                  ) : (
                    <p className="text-gray-500 text-center mt-4 italic">
                      No image available
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {extraAttachments && (
          <h1 className="font-bold md:text-2xl text-gray-800 mt-6">
            Extra Attachments
          </h1>
        )}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {extraAttachments &&
            extraAttachments?.map((item, index) => (
              <div className="my-6" key={index}>
                {item?.fileExt?.includes(".jpg") ||
                item?.url?.includes(".jpg") ||
                item?.fileExt?.includes(".webp") ||
                item?.url?.includes(".webp") ||
                item?.fileExt?.includes(".jpeg") ||
                item?.url?.includes(".jpeg") ||
                item?.fileExt?.includes(".png") ||
                item?.url?.includes(".png") ? (
                  <img
                    src={item?.url ? item?.url : item?.path}
                    alt="Preview"
                    onClick={() => {
                      handleOpen(item?.url ? item?.url : item?.path);
                    }}
                    className="w-full h-72 mt-2 object-contain rounded cursor-pointer"
                  />
                ) : item?.fileExt?.includes(".csv") ||
                  item?.url?.includes(".csv") ||
                  item?.fileExt?.includes(".html") ||
                  item?.url?.includes(".html") ||
                  item?.fileExt?.includes(".pdf") ||
                  item?.url?.includes(".pdf") ||
                  item?.fileExt?.includes(".docx") ||
                  item?.url?.includes(".docx") ||
                  item?.fileExt?.includes(".doc") ||
                  item?.url?.includes(".doc") ? (
                  <>
                    <iframe
                      src={`https://docs.google.com/gview?url=${item?.url}&embedded=true`}
                      width="100%"
                      height="300px"
                    />
                  </>
                ) : item?.fileExt?.includes(".mp4") ||
                  item?.url?.includes(".mp4") ||
                  item?.fileExt?.includes(".mov") ||
                  item?.url?.includes(".mov") ||
                  item?.fileExt?.includes(".mkv") ||
                  item?.url?.includes(".mkv") ? (
                  <>
                    <video className="h-72" controls poster={item?.fileName}>
                      <source src={item?.url} type="video/mp4" />
                    </video>
                  </>
                ) : (
                  <p className="text-gray-500 text-center mt-4 italic">
                    No image available
                  </p>
                )}
              </div>
            ))}
        </div>

        {transactionList.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <h1 className="font-bold md:text-2xl text-gray-800">
              Transaction Details
            </h1>
            <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="dynamic table"
                >
                  <TableHead>
                    <TableRow className="bg-gray-100">
                      {/* Dynamically render headers */}
                      {rows.length > 0 &&
                        Object.keys(rows[0]).map((key) => (
                          <TableCell key={key}>{key}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow key={index}>
                        {Object.entries(row).map(([key, value], idx) => (
                          <TableCell key={idx}>
                            {key === "attachments" && value ? (
                              <div
                                title="image"
                                className="flex gap-4 items-center cursor-pointer"
                              >
                                {value.map((item, index) => (
                                  <div
                                    key={index}
                                    className="items-center gap-2"
                                  >
                                    <img
                                      src={item?.url}
                                      alt="Attachment"
                                      onClick={() => {
                                        handleOpen(item?.url);
                                      }}
                                      className="w-8 h-8 object-contain"
                                    />
                                  </div>
                                ))}
                              </div>
                            ) : (
                              value
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Fueldetailstab;
